module.exports = __webpack_public_path__ + "media/KZ-ATY.26494d91.ogg";